import { render, staticRenderFns } from "./PhysicalProductAdjustmentStockTable.vue?vue&type=template&id=67c3b792"
import script from "./PhysicalProductAdjustmentStockTable.vue?vue&type=script&lang=js"
export * from "./PhysicalProductAdjustmentStockTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports